import { GdasClaimsData, GdasProfile, GdasSellersData, UserInfo } from "../../models";
import { AuthScope } from "../scopes";
import { createAction } from "./internal/platformActionCreators";

export enum AuthActions {
  CHECK_AUTH_STATUS = "@auth/CHECK_AUTH_STATUS",
  UPDATE_USER = "@auth/UPDATE_USER",
  UPDATE_GDAS_PROFILE = "@auth/UPDATE_GDAS_PROFILE",
  UPDATE_GDAS_SELLERS = "@auth/UPDATE_GDAS_SELLERS",
  UPDATE_GDAS_CLAIMS = "@auth/UPDATE_GDAS_CLAIMS",
  SET_ACTIVE_TENANT = "@auth/SET_ACTIVE_TENANT",
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const authActions = {
  checkAuthStatus: createAction(
    AuthActions.CHECK_AUTH_STATUS,
    AuthScope,
    (initialClientSetup: boolean | undefined) => ({ initialClientSetup })
  ),
  updateUser: createAction(
    AuthActions.UPDATE_USER,
    AuthScope,
    (userInfo: UserInfo | undefined) => ({
      userInfo,
    })
  ),
  updateGdasProfile: createAction(
    AuthActions.UPDATE_GDAS_PROFILE,
    AuthScope,
    (gdasProfile: GdasProfile | undefined) => ({ gdasProfile })
  ),
  updateGdasSellers: createAction(
    AuthActions.UPDATE_GDAS_SELLERS,
    AuthScope,
    (gdasSellers: GdasSellersData | undefined) => ({ gdasSellers })
  ),
  updateGdasClaims: createAction(
    AuthActions.UPDATE_GDAS_CLAIMS,
    AuthScope,
    (gdasClaims: GdasClaimsData | undefined) => ({ gdasClaims })
  ),
  setActiveTenant: createAction(AuthActions.SET_ACTIVE_TENANT, AuthScope, (tenantId: string) => ({
    tenantId,
  })),
};
